import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64b09f9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list_content" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","margin":"15px 0"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_OrganizationSet = _resolveComponent("OrganizationSet")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: 16 }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: _ctx.menuText.partyMenu1
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.list.length)
                  ? (_openBlock(), _createBlock(_component_a_tree, {
                      key: 0,
                      "tree-data": _ctx.list,
                      "show-line": true,
                      "block-node": "",
                      "field-names": _ctx.fieldNames,
                      defaultExpandAll: ""
                    }, {
                      title: _withCtx((record) => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("span", null, _toDisplayString(record.name), 1),
                          _createElementVNode("div", null, [
                            _createVNode(_component_a_button, {
                              onClick: ($event: any) => (_ctx.setEdit(record)),
                              style: {"margin":"5px"}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_a_popconfirm, {
                              title: "是否删除?",
                              onConfirm: ($event: any) => (_ctx.onDel(record))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, { style: {"margin":"5px"} }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onConfirm"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["tree-data", "field-names"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { span: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "设置",
            bordered: false,
            class: "add_content"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_OrganizationSet, {
                ref: "setRef",
                "edit-item": _ctx.editItem,
                reset: _ctx.reset
              }, null, 8, ["edit-item", "reset"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}